module.exports = "/_next/static/images/5515a39942f940b5ab0859c8aabfb107-cards@1x.png.webp";